import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import i18n from '../i18n/config'
import { getCountryConfig } from '../lib/country-config'

export default function GoogleAuthSuccess() {
  const navigate = useNavigate()
  const [params] = useSearchParams()

  useEffect(() => {
    const token = params.get('token')
    const user = params.get('user')
    if (token) {
      localStorage.setItem('pakt_token', token)
      if (user) {
        try { localStorage.setItem('pakt_user', decodeURIComponent(user)) } catch {}
      }
      try {
        const uStr = localStorage.getItem('pakt_user')
        if (uStr) {
          const u = JSON.parse(uStr)
          const config = getCountryConfig(u.countryCode || 'BR')
          if (config?.locale) {
            i18n.changeLanguage(config.locale)
            localStorage.setItem('pakt_language', config.locale)
          }
        }
      } catch {}
      navigate('/dashboard', { replace: true })
    } else {
      navigate('/login?error=google_failed', { replace: true })
    }
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600" />
    </div>
  )
}
